export const THRESHOLD_MIN_VALUE = 0;
export const THRESHOLD_MAX_VALUE = 100;
export const TAIL_SPEND_MIN_VALUE = 0;
export const TAIL_SPEND_MAX_VALUE = 99;
export const CUSTOM_CURRENCY_TYPE = 'customCurrency';

export function bytesToSize(bytes) {
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

	if (bytes === 0) {
		return '0 Byte';
	}

	const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

	return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export function validateThresholds(thresholds) {
	const { threshold1, threshold2 } = thresholds;
	const errors = {};

	if (typeof threshold1 !== 'number' && !threshold1) {
		errors.threshold1Emtpy = 'Threshold 1 must not be empty';
	}

	if (typeof threshold2 !== 'number' && !threshold2) {
		errors.threshold2Emtpy = 'Threshold 2 must not be empty';
	}

	if (threshold1 < THRESHOLD_MIN_VALUE || threshold1 > THRESHOLD_MAX_VALUE) {
		errors.threshold1MinMax = 'Threshold 1 must be from 0 to 100';
	}

	if (threshold2 < THRESHOLD_MIN_VALUE || threshold2 > THRESHOLD_MAX_VALUE) {
		errors.threshold2MinMax = 'Threshold 2 must be from 0 to 100';
	}

	if (
		typeof threshold1 === 'number' &&
		typeof threshold2 === 'number' &&
		threshold1 >= threshold2
	) {
		errors.threshold1More = 'Threshold 1 must be lower than Threshold 2';
	}

	return errors;
}

export function validateTailSpend(tailSpendValue) {
	const errors = {};

	if (typeof tailSpendValue !== 'number' && !tailSpendValue) {
		errors.tailSpendValueEmtpy = 'Spend Cube value must not be empty';
	}

	return errors;
}

export function getISOString(year, month, isLastDay) {
	let day = 1;

	if (isLastDay) {
		day = new Date(year, month, 0).getDate();
	}

	const monthString = month < 10 ? `0${month}` : month;
	const dayString = day < 10 ? `0${day}` : day;

	const d = new Date(`${year}-${monthString}-${dayString}`);

	return d.toISOString().slice(0, -1);
}

export const serializePeriod = monthPickerRange => ({
	dateFrom: getISOString(
		monthPickerRange.from.year,
		monthPickerRange.from.monthNumber
	),
	dateTo: getISOString(
		monthPickerRange.to.year,
		monthPickerRange.to.monthNumber,
		true
	),
});

export const SEGMENT_MAX_VALUE = 7 * 10 ** 15;
export const getTailSpendAnalysisConfigurationForSave = tailSpendAnalysisConfiguration => {
	if (
		!tailSpendAnalysisConfiguration ||
		!tailSpendAnalysisConfiguration.segments ||
		tailSpendAnalysisConfiguration.segments.length === 0
	) {
		return tailSpendAnalysisConfiguration;
	}

	const { segments = [] } = tailSpendAnalysisConfiguration;
	const segmentsCopy = [...segments];

	const firstSegment = segmentsCopy[0];
	segmentsCopy[0] = { ...firstSegment, start: -1 * SEGMENT_MAX_VALUE };

	const lastSegment = segmentsCopy[segmentsCopy.length - 1];
	segmentsCopy[segmentsCopy.length - 1] = {
		...lastSegment,
		end: SEGMENT_MAX_VALUE,
	};

	return { ...tailSpendAnalysisConfiguration, segments: segmentsCopy };
};

export const getTailSpendAnalysisConfigurationForProcessing = tailSpendAnalysisConfiguration => {
	if (
		!tailSpendAnalysisConfiguration ||
		!tailSpendAnalysisConfiguration.segments ||
		tailSpendAnalysisConfiguration.segments.length === 0
	) {
		return tailSpendAnalysisConfiguration;
	}

	const { segments = [] } = tailSpendAnalysisConfiguration;
	const segmentsCopy = [...segments];

	const firstSegment = segmentsCopy[0];
	segmentsCopy[0] = {
		...firstSegment,
		start: Number.NEGATIVE_INFINITY,
	};

	const lastSegment = segmentsCopy[segmentsCopy.length - 1];
	segmentsCopy[segmentsCopy.length - 1] = {
		...lastSegment,
		end: Number.POSITIVE_INFINITY,
	};

	return { ...tailSpendAnalysisConfiguration, segments: segmentsCopy };
};

export const getDuplicateArrayElements = arr => {
	const sortedArray = arr.slice().sort();
	const results = [];

	for (var i = 0; i < sortedArray.length - 1; i++) {
		if (
			sortedArray[i + 1] === sortedArray[i] &&
			!results.includes(sortedArray[i])
		) {
			results.push(sortedArray[i]);
		}
	}
	return results;
};
